import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=f9dbf96e&"
import script from "./MenuTable.vue?vue&type=script&lang=js&"
export * from "./MenuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports